// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1driX","insightsList":"newBusinessInsightsMenu_insightsList__1ExUV","active":"newBusinessInsightsMenu_active__15-H2"};